// components
import { FilterChips } from '@/pwa/molecules/FilterChips/FilterChips';

interface OrganiserCareCircle {
  id: string;
  name: string;
  color: string;
}

interface CareCircleFilterProps {
  careCircles: OrganiserCareCircle[];
  activeCareCircleIds: string[];
  onActiveCareCircleIdsChange: (ids: string[]) => void;
}

export const CareCircleFilter = ({
  careCircles,
  activeCareCircleIds,
  onActiveCareCircleIdsChange,
}: CareCircleFilterProps) => {
  return (
    <FilterChips
      activeIds={
        activeCareCircleIds.length === careCircles.length
          ? ['__all__']
          : activeCareCircleIds
      }
      items={[
        {
          id: '__all__',
          label: 'Show all',
          onClick: () =>
            onActiveCareCircleIdsChange(careCircles.map((cc) => cc.id)),
        },
        ...careCircles.map((cc) => ({
          id: cc.id,
          label: cc.name,
          onClick: () => {
            if (
              activeCareCircleIds.length === 1 &&
              activeCareCircleIds[0] === cc.id
            )
              return;
            onActiveCareCircleIdsChange([cc.id]);
          },
        })),
      ]}
    />
  );
};
